export enum ReferenceTariffType {
  average = 'average',
  invoice = 'invoice',
}
